import { render } from "./TableLayout.vue?vue&type=template&id=0686021c"
import script from "./TableLayout.vue?vue&type=script&lang=js"
export * from "./TableLayout.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/survey-cms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__